export enum GuestActionType {
    DIALOG = "DIALOG",
    DICE_ROLL = "DICE_ROLL",
    SCREEN = "SCREEN",
    NEWS = "NEWS"
}